import React from 'react';
import { render } from 'react-dom';
import configureStore from './store/configureStore';
import { Provider } from 'react-redux';
import { Route } from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom'
import { PersistGate } from "redux-persist/es/integration/react";
import "typeface-roboto";
import App from './containers/App/App';

const { store, persistor } = configureStore();

const loadingSegment = <span>loading</span>;


render(
  <Provider store={store}>
  <PersistGate loading={loadingSegment} persistor={persistor}>
    <BrowserRouter>
      <Route path="/" component={App} />
    </BrowserRouter> 
    </PersistGate>
  </Provider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js